import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export function CircularLoading() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress />
    </Box>
  );
}

export default CircularLoading;
